export const defaultError = [
  'error',
  'Ocorreu um erro ao gerar o boleto',
  'Tente novamente mais tarde',
] as const;

export enum PrivatePensionNewApplicationModalSteps {
  APPLICATION_FORM = 1,
  SUCCESS = 2,
}
